export default "__VITE_ASSET__BTlWbOvt__"